export { default } from './EzAlert.vue';
